<template>
    <div class="pull-right actions">
        <a href="#" class="btn-finance" @click="showModal"><i class="fa fa-plus-circle"></i>Add Check</a>
        <a :href="creditcardlink" class="btn-finance"><i class="fa fa-plus-circle"></i>Credit Card</a>

        <b-modal size="lg" ref="finance-modal" hide-footer>
            <template v-slot:modal-header="{ close }">
                <div class="p-4 position-relative d-inline-block col-12">
                    <h2 class="description mb-0">Assign Check</h2>
                    <i class="close-icon modal-close" @click="close()"></i>
                </div>
            </template>

            <div id="modal-content" class="modal-content-area entries-delete-modal pl-4 pr-4">
                <form id="finance-form-data">
                    <h4>Invoice #</h4>
                    <span id="invoiceid-text" v-text="invoice"></span>
                    <div class="invoice-wrapper-grey">
                        <div class="invoice-wrap-half">
                            <label>Check #</label>
                            <input type="text" name="check" v-model="checkNum" />
                        </div>
                        <div class="invoice-wrap-half last">
                            <label>Check Amount</label>
                            <input type="text" name="amount" v-model="amount" />
                        </div>
                        <div class="invoice-wrap-full">
                            <label>Note</label>
                            <textarea name="note" v-model="note"></textarea>
                        </div>
                    </div>
                    <a class="btn btn-default btn-grey modal-close" @click="hideModal">Cancel</a>
                    <a class="btn btn-default pull-right" @click="financeSubmitCheck()"><i class="fa fa-save"></i>Save</a>
                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: ['amountinput', 'invoice', 'order', 'creditcardlink'],
        data() {
            return {
                checkNum: '',
                amount: (this.amountinput) ? this.amountinput : 0,
                note: '',
                orderId: this.order
            }
        },
        methods: {
            showModal() {
                this.$refs['finance-modal'].show()
            },
            hideModal() {
                this.$refs['finance-modal'].hide()
            },
            financeSubmitCheck() {
                let app = this;
                var data = $('form#finance-form-data').serialize();
                data += "&orderid=" + app.orderId;
                $.ajax({
                    type: "POST",
                    url: '/api/order/recordcheck',
                    data: data,
                    dataType: 'json',
                    success: function (data) {
                        console.log('Check has been sent');
                        let orders = app.orderId.split(';');
                        jQuery.each(orders, function(i, orderId){
                            $('.order-'+orderId).remove();
                        });
                        app.hideModal();
                    },
                    error: function (data) {
                        console.log("error saving check");
                    }
                });
            }
        }
    }
</script>

